<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="mb-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{labels.applicant}}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-autocomplete key="appSalutation" :items="salutationList" v-model="maidForm.applicant.appSalutation" :label="labels.appSalutation" item-text="label" item-value="value" data-vv-name="appSalutation" :data-vv-as="labels.appSalutation" :error-messages="errors.collect('appSalutation')" v-validate="'required'" @input="doSalutation"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="appName" v-model="maidForm.applicant.appName" :label="labels.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="labels.appName" v-validate="'required|name|max:50'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-autocomplete key="appNationality" :items="appNationalityList" v-model="maidForm.applicant.appNationality" :label="labels.appNationality" item-text="label" item-value="value" data-vv-name="appNationality" :data-vv-as="labels.appNationality" :error-messages="errors.collect('appNationality')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="appNricPassport" v-uppercase="maidForm.applicant.appNricPassport" v-model="maidForm.applicant.appNricPassport" :label="labels.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="labels.appNricPassport" v-validate="'required|alpha_num|max:20'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <cal-picker key="appDob" v-model="maidForm.applicant.appDob" :label="labels.appDob" v-validate="{ required: true, bday_range:[globalCommonForm.startDate, 21, 100]}" :data-vv-as="labels.appDob" data-vv-name="appDob" :error-messages="errors.collect('appDob')"></cal-picker>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-radio-group key="appGender" v-model="maidForm.applicant.appGender" row :label="labels.appGender" :error-messages="errors.collect('appGender')" data-vv-name="appGender" :data-vv-as="labels.appGender" v-validate="'required'">
                    <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="appOccupation" v-model="maidForm.applicant.appOccupation" :label="labels.appOccupation" :error-messages="errors.collect('appOccupation')" data-vv-name="appOccupation" :data-vv-as="labels.appOccupation" v-validate="'name|max:60'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="appEmployerName" v-model="maidForm.applicant.appEmployerName" :label="labels.appEmployerName" :error-messages="errors.collect('appEmployerName')" data-vv-name="appEmployerName" :data-vv-as="labels.appEmployerName" v-validate="'name|max:60'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appContact}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.appEmail" type="email" :label="labels.appEmail" :error-messages="errors.collect('appEmail')" data-vv-name="appEmail" :data-vv-as="labels.appEmail" v-validate="'required|email'" prepend-icon="mdi-email" hint="An email acknowledgement will be sent to this address" :persistent-hint="true"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.appMobileNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.appMobileNo" :error-messages="errors.collect('appMobileNo')" data-vv-name="appMobileNo" :data-vv-as="labels.appMobileNo" :v-validate="{numeric:true}" hint="Mobile No. is required to receive SMS confirmation" :persistent-hint="true" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.appTelNo1" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo1" :error-messages="errors.collect('appTelNo1')" data-vv-name="appTelNo1" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.appTelNo2" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo2" :error-messages="errors.collect('appTelNo2')" data-vv-name="appTelNo2" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.appAdd3" :label="labels.appAdd3" :error-messages="errors.collect('appAdd3')" data-vv-name="appAdd3" :data-vv-as="labels.appAdd3" prefix="#" v-validate="'unit_no|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.appPostalCode" :label="labels.appPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('appPostalCode')" data-vv-name="appPostalCode" :data-vv-as="labels.appPostalCode" v-validate="'required|numeric'" :loading="appPostalCodeLoading" @change="doAppAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.appAdd1" :label="labels.appAdd1" :error-messages="errors.collect('appAdd1')" data-vv-name="appAdd1" :data-vv-as="labels.appAdd1" v-validate="'required|entry|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.appAdd2" :label="labels.appAdd2" :error-messages="errors.collect('appAdd2')" data-vv-name="appAdd2" :data-vv-as="labels.appAdd2" v-validate="'required|entry|max:255'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.appAdd4" :label="labels.appAdd4" :error-messages="errors.collect('appAdd4')" data-vv-name="appAdd4" :data-vv-as="labels.appAdd4" v-validate="'entry|max:255'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.mailAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="maidForm.applicant.mailAdd" :label="labels.mailAdd" data-vv-name="mailAdd" :data-vv-as="labels.mailAdd" :error-messages="errors.collect('mailAdd')" @change="doMailAdd" hide-details></v-checkbox>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.mailAdd3" :label="labels.mailAdd3" :error-messages="errors.collect('mailAdd3')" data-vv-name="mailAdd3" :data-vv-as="labels.mailAdd3" prefix="#" v-validate="'entry|max:30'" :readonly="maidForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.mailPostalCode" :label="labels.mailPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('mailPostalCode')" data-vv-name="mailPostalCode" :readonly="maidForm.applicant.mailAdd" :data-vv-as="labels.mailPostalCode" v-validate="'numeric'" :loading="mailPostalCodeLoading" @change="doMailAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.mailAdd1" :label="labels.mailAdd1" :error-messages="errors.collect('mailAdd1')" data-vv-name="mailAdd1" :data-vv-as="labels.mailAdd1" v-validate="'entry|max:30'" :readonly="maidForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.mailAdd2" :label="labels.mailAdd2" :error-messages="errors.collect('mailAdd2')" data-vv-name="mailAdd2" :data-vv-as="labels.mailAdd2" v-validate="'entry|max:255'" :readonly="maidForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.applicant.mailAdd4" :label="labels.mailAdd4" :error-messages="errors.collect('mailAdd4')" data-vv-name="mailAdd4" :data-vv-as="labels.mailAdd4" v-validate="'entry|max:255'" :readonly="maidForm.applicant.mailAdd"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="maidForm.applicant.appJointScheme" :label="labels.appJointScheme" data-vv-name="appJointScheme" :data-vv-as="labels.appJointScheme" :error-messages="errors.collect('appJointScheme')" :hint="labels.appJointSchemeInfo" persistent-hint></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="maidForm.applicant.appJointScheme">
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{labels.guarantor}}</h3>
              <span class="grey--text">{{labels.gtInfo}}</span>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-autocomplete key="gtSalutation" :items="salutationList" v-model="maidForm.guarantor.gtSalutation" :label="labels.gtSalutation" item-text="label" item-value="value" data-vv-name="gtSalutation" :data-vv-as="labels.gtSalutation" :error-messages="errors.collect('gtSalutation')" v-validate="'required'" @input="doGtSalutation"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="gtName" v-model="maidForm.guarantor.gtName" :label="labels.gtName" :error-messages="errors.collect('gtName')" data-vv-name="gtName" :data-vv-as="labels.gtName" v-validate="'required|name|max:60'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-autocomplete key="gtNationality" :items="gtNationalityList" v-model="maidForm.guarantor.gtNationality" :label="labels.gtNationality" item-text="label" item-value="value" data-vv-name="gtNationality" :data-vv-as="labels.gtNationality" :error-messages="errors.collect('gtNationality')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="gtNric" v-uppercase="maidForm.guarantor.gtNric" v-model="maidForm.guarantor.gtNric" :label="labels.gtNric" :error-messages="errors.collect('gtNric')" data-vv-name="gtNric" :data-vv-as="labels.gtNric" v-validate="'required|entry|nric'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <cal-picker key="gtDob" v-model="maidForm.guarantor.gtDob" :label="labels.gtDob" v-validate="{ required: true, bday_range:[globalCommonForm.startDate, 21, 100]}" :data-vv-as="labels.gtDob" data-vv-name="gtDob" :error-messages="errors.collect('gtDob')"></cal-picker>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-radio-group key="gtGender" v-model="maidForm.guarantor.gtGender" row :label="labels.gtGender" :error-messages="errors.collect('gtGender')" data-vv-name="gtGender" :data-vv-as="labels.gtGender" v-validate="'required'">
                    <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="gtOccupation" v-model="maidForm.guarantor.gtOccupation" :label="labels.gtOccupation" :error-messages="errors.collect('gtOccupation')" data-vv-name="gtOccupation" :data-vv-as="labels.gtOccupation" v-validate="'name|max:60'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="gtEmployerName" v-model="maidForm.guarantor.gtEmployerName" :label="labels.gtEmployerName" :error-messages="errors.collect('gtEmployerName')" data-vv-name="gtEmployerName" :data-vv-as="labels.gtEmployerName" v-validate="'name|max:60'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field class="mavPrefix" v-num-mask v-model="maidForm.guarantor.gtEstAnnualIncome" :label="labels.gtEstAnnualIncome" type="tel" :error-messages="errors.collect('gtEstAnnualIncome')" data-vv-name="gtEstAnnualIncome" :data-vv-as="labels.gtEstAnnualIncome" v-validate="'mask_decimal:2|mask_min_value:1|mask_max_value:99999999.99'" :prefix="$store.state.agency.quotation.commonInfo.currPrefix"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.gtContact}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.guarantor.gtEmail" type="email" :label="labels.gtEmail" :error-messages="errors.collect('gtEmail')" data-vv-name="gtEmail" :data-vv-as="labels.gtEmail" v-validate="'email'" prepend-icon="mdi-email"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.guarantor.gtMobileNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.gtMobileNo" :error-messages="errors.collect('gtMobileNo')" data-vv-name="gtMobileNo" :data-vv-as="labels.gtMobileNo" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.guarantor.gtTelNo1" v-int-mask="{intScale: 8}" type="tel" :label="labels.gtTelNo1" :error-messages="errors.collect('gtTelNo1')" data-vv-name="gtTelNo1" :data-vv-as="labels.gtTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.guarantor.gtTelNo2" v-int-mask="{intScale: 8}" type="tel" :label="labels.gtTelNo2" :error-messages="errors.collect('gtTelNo2')" data-vv-name="gtTelNo2" :data-vv-as="labels.gtTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.gtAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="maidForm.guarantor.gtAdd" :label="labels.gtAdd" data-vv-name="gtAdd" :data-vv-as="labels.gtAdd" :error-messages="errors.collect('gtAdd')" @change="doGtAdd" hide-details></v-checkbox>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.guarantor.gtAdd3" :label="labels.gtAdd3" :error-messages="errors.collect('gtAdd3')" data-vv-name="gtAdd3" :data-vv-as="labels.gtAdd3" prefix="#" v-validate="'entry|max:30'" :readonly="maidForm.guarantor.gtAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.guarantor.gtPostalCode" :label="labels.gtPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('gtPostalCode')" data-vv-name="gtPostalCode" :readonly="maidForm.guarantor.gtAdd" :data-vv-as="labels.gtPostalCode" v-validate="'numeric'" :loading="gtPostalCodeLoading" @change="doGtAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.guarantor.gtAdd1" :label="labels.gtAdd1" :error-messages="errors.collect('gtAdd1')" data-vv-name="gtAdd1" :data-vv-as="labels.gtAdd1" v-validate="'entry|max:30'" :readonly="maidForm.guarantor.gtAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.guarantor.gtAdd2" :label="labels.gtAdd2" :error-messages="errors.collect('gtAdd2')" data-vv-name="gtAdd2" :data-vv-as="labels.gtAdd2" v-validate="'entry|max:255'" :readonly="maidForm.guarantor.gtAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="maidForm.guarantor.gtAdd4" :label="labels.gtAdd4" :error-messages="errors.collect('gtAdd4')" data-vv-name="gtAdd4" :data-vv-as="labels.mailAdd4" v-validate="'entry|max:255'" :readonly="maidForm.guarantor.gtAdd"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{labels.fw}}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field key="fwTransNo" v-uppercase v-model="maidForm.fw.fwTransNo" :label="labels.fwTransNo" :error-messages="errors.collect('fwTransNo')" data-vv-name="fwTransNo" :data-vv-as="labels.fwTransNo" v-validate="'required|sbTransNo'" :hint="labels.fwTransNoInfo" persistent-hint :maxlength="20"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-autocomplete key="fwWPType" :items="workPermitTypeList" v-model="maidForm.fw.fwWPType" :label="labels.fwWPType" item-text="label" item-value="value" data-vv-name="fwWPType" :data-vv-as="labels.fwWPType" :error-messages="errors.collect('fwWPType')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="fwWPNo" v-fwwpnp v-model="maidForm.fw.fwWPNo" :label="labels.fwWPNo" :error-messages="errors.collect('fwWPNo')" data-vv-name="fwWPNo" :data-vv-as="labels.fwWPNo" v-validate="'required|fwWPNo'" :hint="labels.fwWPNoInfo" persistent-hint></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="fwName" v-model="maidForm.fw.fwName" :label="labels.fwName" :error-messages="errors.collect('fwName')" data-vv-name="fwName" :data-vv-as="labels.fwName" v-validate="'required|name|max:60'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-autocomplete key="fwNationality" :items="maidNationalityList" v-model="maidForm.fw.fwNationality" :label="labels.fwNationality" item-text="label" item-value="value" data-vv-name="fwNationality" :data-vv-as="labels.fwNationality" :error-messages="errors.collect('fwNationality')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field key="fwPassport" v-uppercase="maidForm.fw.fwPassport" v-model="maidForm.fw.fwPassport" :label="labels.fwPassport" :error-messages="errors.collect('fwPassport')" data-vv-name="fwPassport" :data-vv-as="labels.fwPassport" v-validate="'required|entry|max:20'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <cal-picker key="fwDob" v-model="maidForm.fw.fwDob" :label="labels.fwDob" v-validate="fwWPNoValidation" :data-vv-as="labels.fwDob" data-vv-name="fwDob" :error-messages="errors.collect('fwDob')"></cal-picker>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-radio-group key="fwGender" v-model="maidForm.fw.fwGender" row :label="labels.fwGender" :error-messages="errors.collect('fwGender')" data-vv-name="fwGender" :data-vv-as="labels.fwGender" v-validate="'required'">
                    <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_MAID_RISK } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { salutation, gender, maritalStatus } from '@/const/underwriting'
import { maidNationality, workPermitType, appNationality, gtNationality } from '@/const/underwriting/maid'
import { expandURI } from '@/utils/ajax'
import mask from '@/directives/cleaveDynamicMask'
import toDate from 'date-fns/toDate'

export default {
  data() {
    return {
      labels: {
        applicant: 'Applicant',
        appName: 'Name as in NRIC/Passport',
        appNationality: 'Nationality*',
        appSalutation: 'Salutation*',
        appNricPassport: 'NRIC/Passport*',
        appDob: 'Date of Birth*',
        appGender: 'Gender*',
        appOccupation: 'Business/Profession',
        appEmployerName: 'Name of Employer',
        appJointScheme: 'Application under Joint Income/Sponsorship Scheme',
        appJointSchemeInfo: 'Local Guarantor is required for FDW application under Joint Income/Sponsorship Scheme',
        appAddress: 'Applicant Address',
        mailAddress: 'Mailing Address',
        appAdd1: 'Block/House No.*',
        appAdd2: 'Street Name*',
        appAdd3: 'Unit No.',
        appAdd4: 'Building Name',
        appPostalCode: 'Postal Code*',
        mailAdd: 'Same as Applicant Address',
        mailAdd1: 'Block/House No.',
        mailAdd2: 'Street Name',
        mailAdd3: 'Unit No.',
        mailAdd4: 'Building Name',
        mailPostalCode: 'Postal Code',
        appContact: 'Contacts',
        appEmail: 'Email*',
        appMobileNo: 'Mobile No.',
        appTelNo1: 'Home No.',
        appTelNo2: 'Office No',
        guarantor: 'Guarantor',
        gtInfo: 'Guarantor has to be a Singaporean/PR',
        gtSalutation: 'Salutation*',
        gtName: 'Name as in NRIC*',
        gtNationality: 'Nationality*',
        gtNric: 'NRIC*',
        gtDob: 'Date of Birth*',
        gtGender: 'Gender*',
        gtOccupation: 'Business/Profession',
        gtEmployerName: 'Name of Employer',
        gtEstAnnualIncome: 'Estimated Annual Income',
        gtContact: 'Contacts',
        gtEmail: 'Email',
        gtMobileNo: 'Mobile No.',
        gtTelNo1: 'Home No.',
        gtTelNo2: 'Office No',
        gtAddress: 'Guarantor Address',
        gtAdd: 'Same as Applicant Address',
        gtAdd1: 'Block/House No.',
        gtAdd2: 'Street Name',
        gtAdd3: 'Unit No.',
        gtAdd4: 'Building Name',
        gtPostalCode: 'Postal Code',
        fw: 'Foreign Domestic Worker',
        // fwTransNo: 'SB Transmission No.*',
        fwTransNo: 'SB Transmission No. / Employer NRIC/FIN No.*',
        fwTransNoInfo: 'Refers to your In-Principle Approval/Renewal Letter from MOM',
        fwName: 'Name as in Passport*',
        fwNationality: 'Nationality*',
        // fwPassport: 'Passport No.*',
        fwPassport: 'Worker FIN No.*',
        fwDob: 'Date of Birth*',
        fwGender: 'Gender*',
        fwWPNo: 'Work Permit No.*',
        fwWPNoInfo: 'Refers to your In-Principle Approval/Renewal Letter from MOM',
        fwWPType: 'Work Permit Type*'
      },
      maidForm: {
        applicant: {
          appSalutation: undefined,
          appName: undefined,
          appNationality: undefined,
          appNricPassport: undefined,
          appDob: undefined,
          appGender: undefined,
          appOccupation: undefined,
          appEmployerName: undefined,
          appJointScheme: false,
          appEmail: undefined,
          appMobileNo: undefined,
          appTelNo1: undefined,
          appTelNo2: undefined,
          appPostalCode: undefined,
          appAdd1: undefined,
          appAdd2: undefined,
          appAdd3: undefined,
          appAdd4: undefined,
          mailAdd: undefined,
          mailPostalCode: undefined,
          mailAdd1: undefined,
          mailAdd2: undefined,
          mailAdd3: undefined,
          mailAdd4: undefined
        },
        guarantor: {
          gtSalutation: undefined,
          gtName: undefined,
          gtNationality: undefined,
          gtNric: undefined,
          gtDob: undefined,
          gtGender: undefined,
          gtOccupation: undefined,
          gtEmployerName: undefined,
          gtEstAnnualIncome: undefined,
          gtEmail: undefined,
          gtMobileNo: undefined,
          gtTelNo1: undefined,
          gtTelNo2: undefined,
          gtAdd: undefined,
          gtPostalCode: undefined,
          gtAdd1: undefined,
          gtAdd2: undefined,
          gtAdd3: undefined,
          gtAdd4: undefined
        },
        fw: {
          fwTransNo: undefined,
          fwName: undefined,
          fwNationality: undefined,
          fwPassport: undefined,
          fwDob: undefined,
          fwGender: undefined,
          fwWPNo: undefined,
          fwWPType: undefined
        }
      },
      appPostalCodeLoading: false,
      mailPostalCodeLoading: false,
      gtPostalCodeLoading: false
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.maidParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.maidForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maritalStatusList() {
      let result = []
      Object.keys(maritalStatus).forEach(function (key) {
        const status = maritalStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maidNationalityList() {
      let result = []
      Object.keys(maidNationality).forEach(function (key) {
        const status = maidNationality[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    workPermitTypeList() {
      let result = []
      Object.keys(workPermitType).forEach(function (key) {
        const status = workPermitType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    fwWPNoValidation() {
      let result = 'required'
      if (this.maidForm.fw.fwWPType && this.maidForm.fw.fwWPType === 'R') {
        result = {
          required: true,
          bday_range: [
            this.globalCommonForm.startDate,
            23,
            60
          ]
        }
      } else {
        result = {
          required: true,
          bday_range: [
            this.globalCommonForm.startDate,
            23,
            50
          ]
        }
      }
      return result
    },
    appNationalityList() {
      let result = []
      Object.keys(appNationality).forEach(function (key) {
        const status = appNationality[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    gtNationalityList() {
      let result = []
      Object.keys(gtNationality).forEach(function (key) {
        const status = gtNationality[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  watch: {
    'maidForm.applicant.appAdd1': function (value) {
      if (this.maidForm.applicant.mailAdd) {
        this.maidForm.applicant.mailAdd1 = value
      }
      if (this.maidForm.guarantor.gtAdd) {
        this.maidForm.guarantor.gtAdd1 = value
      }
    },
    'maidForm.applicant.appAdd2': function (value) {
      if (this.maidForm.applicant.mailAdd) {
        this.maidForm.applicant.mailAdd2 = value
      }
      if (this.maidForm.guarantor.gtAdd) {
        this.maidForm.guarantor.gtAdd2 = value
      }
    },
    'maidForm.applicant.appAdd3': function (value) {
      if (this.maidForm.applicant.mailAdd) {
        this.maidForm.applicant.mailAdd3 = value
      }
      if (this.maidForm.guarantor.gtAdd) {
        this.maidForm.guarantor.gtAdd3 = value
      }
    },
    'maidForm.applicant.appAdd4': function (value) {
      if (this.maidForm.applicant.mailAdd) {
        this.maidForm.applicant.mailAdd4 = value
      }
      if (this.maidForm.guarantor.gtAdd) {
        this.maidForm.guarantor.gtAdd4 = value
      }
    },
    'maidForm.applicant.appPostalCode': function (value) {
      if (this.maidForm.applicant.mailAdd) {
        this.maidForm.applicant.mailPostalCode = value
      }
      if (this.maidForm.guarantor.gtAdd) {
        this.maidForm.guarantor.gtPostalCode = value
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      // Applicant
      const { applicant } = this.globalCommonForm
      this.maidForm.applicant.appSalutation = applicant.appSalutation
      this.maidForm.applicant.appName = applicant.appName
      this.maidForm.applicant.appNationality = applicant.appNationality
      this.maidForm.applicant.appGender = applicant.appGender
      this.maidForm.applicant.appNricPassport = applicant.appNricPassport
      if (applicant.appDob) {
        this.maidForm.applicant.appDob = toDate(applicant.appDob)
      }
      this.maidForm.applicant.appOccupation = applicant.appOccupation
      this.maidForm.applicant.appEmployerName = applicant.appEmployerName
      this.maidForm.applicant.appJointScheme = applicant.appJointScheme
      this.maidForm.applicant.appEmail = applicant.appEmail
      this.maidForm.applicant.appMobileNo = applicant.appMobileNo
      this.maidForm.applicant.appTelNo1 = applicant.appTelNo1
      this.maidForm.applicant.appTelNo2 = applicant.appTelNo2
      this.maidForm.applicant.appPostalCode = applicant.appPostalCode
      this.maidForm.applicant.appAdd1 = applicant.appAdd1
      this.maidForm.applicant.appAdd2 = applicant.appAdd2
      this.maidForm.applicant.appAdd3 = applicant.appAdd3
      this.maidForm.applicant.appAdd4 = applicant.appAdd4
      this.maidForm.applicant.mailAdd = applicant.mailAdd
      this.maidForm.applicant.mailPostalCode = applicant.mailPostalCode
      this.maidForm.applicant.mailAdd1 = applicant.mailAdd1
      this.maidForm.applicant.mailAdd2 = applicant.mailAdd2
      this.maidForm.applicant.mailAdd3 = applicant.mailAdd3
      this.maidForm.applicant.mailAdd4 = applicant.mailAdd4

      this.maidForm.guarantor.gtSalutation = this.globalForm.gtSalutation
      this.maidForm.guarantor.gtName = this.globalForm.gtName
      this.maidForm.guarantor.gtNationality = this.globalForm.gtNationality
      this.maidForm.guarantor.gtNric = this.globalForm.gtNric
      if (this.globalForm.gtDob) {
        this.maidForm.guarantor.gtDob = toDate(this.globalForm.gtDob)
      }
      this.maidForm.guarantor.gtGender = this.globalForm.gtGender
      this.maidForm.guarantor.gtOccupation = this.globalForm.gtOccupation
      this.maidForm.guarantor.gtEmployerName = this.globalForm.gtEmployerName
      this.maidForm.guarantor.gtEstAnnualIncome = this.globalForm.gtEstAnnualIncome
      this.maidForm.guarantor.gtEmail = this.globalForm.gtEmail
      this.maidForm.guarantor.gtMobileNo = this.globalForm.gtMobileNo
      this.maidForm.guarantor.gtTelNo1 = this.globalForm.gtTelNo1
      this.maidForm.guarantor.gtTelNo2 = this.globalForm.gtTelNo2
      this.maidForm.guarantor.gtAdd = this.globalForm.gtAdd
      this.maidForm.guarantor.gtPostalCode = this.globalForm.gtPostalCode
      this.maidForm.guarantor.gtAdd1 = this.globalForm.gtAdd1
      this.maidForm.guarantor.gtAdd2 = this.globalForm.gtAdd2
      this.maidForm.guarantor.gtAdd3 = this.globalForm.gtAdd3
      this.maidForm.guarantor.gtAdd4 = this.globalForm.gtAdd4

      this.maidForm.fw.fwTransNo = this.globalForm.fwTransNo
      this.maidForm.fw.fwName = this.globalForm.fwName
      this.maidForm.fw.fwNationality = this.globalForm.fwNationality
      this.maidForm.fw.fwPassport = this.globalForm.fwPassport
      if (this.globalForm.fwDob) {
        this.maidForm.fw.fwDob = toDate(this.globalForm.fwDob)
      }
      this.maidForm.fw.fwGender = this.globalForm.fwGender || 'F'
      this.maidForm.fw.fwWPNo = this.globalForm.fwWPNo
      this.maidForm.fw.fwWPType = this.globalForm.fwWPType

      // Default values
      if (!this.maidForm.fw.fwWPType && this.workPermitTypeList && this.workPermitTypeList.length > 0) {
        // Default 1st value if not found
        this.maidForm.fw.fwWPType = this.workPermitTypeList[0].value
      }
    },
    doSalutation() {
      if (this.maidForm.applicant.appSalutation === 'MR') {
        this.maidForm.applicant.appGender = 'M'
      } else if (this.maidForm.applicant.appSalutation === 'MS' || this.maidForm.applicant.appSalutation === 'MDM' || this.maidForm.applicant.appSalutation === 'MRS') {
        this.maidForm.applicant.appGender = 'F'
      } else {
        if (!this.maidForm.applicant.appGender || this.maidForm.applicant.appGender === null) {
          this.maidForm.applicant.appGender = 'M'
        }
      }
    },
    doGtSalutation() {
      if (this.maidForm.guarantor.gtSalutation === 'MR') {
        this.maidForm.guarantor.gtGender = 'M'
      } else if (this.maidForm.guarantor.gtSalutation === 'MS' || this.maidForm.guarantor.gtSalutation === 'MDM' || this.maidForm.guarantor.gtSalutation === 'MRS') {
        this.maidForm.guarantor.gtGender = 'F'
      } else {
        if (!this.maidForm.guarantor.gtGender || this.maidForm.guarantor.gtGender === null) {
          this.maidForm.guarantor.gtGender = 'M'
        }
      }
    },
    async doAppAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.appPostalCodeLoading = true
          const expand = {
            postCode: this.maidForm.applicant.appPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.maidForm.applicant.appAdd1 = data.add1
            this.maidForm.applicant.appAdd2 = data.add2
            this.maidForm.applicant.appAdd4 = data.add4
          }
          this.appPostalCodeLoading = false
        } catch (err) {
          this.appPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doMailAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.mailPostalCodeLoading = true
          const expand = {
            postCode: this.maidForm.applicant.mailPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.maidForm.applicant.mailAdd1 = data.add1
            this.maidForm.applicant.mailAdd2 = data.add2
            this.maidForm.applicant.mailAdd4 = data.add4
          }
          this.mailPostalCodeLoading = false
        } catch (err) {
          this.mailPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doGtAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.gtPostalCodeLoading = true
          const expand = {
            postCode: this.maidForm.guarantor.gtPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.maidForm.guarantor.gtAdd1 = data.add1
            this.maidForm.guarantor.gtAdd2 = data.add2
            this.maidForm.guarantor.gtAdd4 = data.add4
          }
          this.gtPostalCodeLoading = false
        } catch (err) {
          this.gtPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doMailAdd() {
      this.maidForm.applicant.mailAdd1 = this.maidForm.applicant.appAdd1
      this.maidForm.applicant.mailAdd2 = this.maidForm.applicant.appAdd2
      this.maidForm.applicant.mailAdd3 = this.maidForm.applicant.appAdd3
      this.maidForm.applicant.mailAdd4 = this.maidForm.applicant.appAdd4
      this.maidForm.applicant.mailPostalCode = this.maidForm.applicant.appPostalCode
    },
    doGtAdd() {
      this.maidForm.guarantor.gtAdd1 = this.maidForm.applicant.appAdd1
      this.maidForm.guarantor.gtAdd2 = this.maidForm.applicant.appAdd2
      this.maidForm.guarantor.gtAdd3 = this.maidForm.applicant.appAdd3
      this.maidForm.guarantor.gtAdd4 = this.maidForm.applicant.appAdd4
      this.maidForm.guarantor.gtPostalCode = this.maidForm.applicant.appPostalCode
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'maidQuotePlans' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.maidForm.applicant.appMobileNo && this.maidForm.applicant.appMobileNo !== '') ||
            (this.maidForm.applicant.appTelNo1 && this.maidForm.applicant.appTelNo1 !== '') ||
            (this.maidForm.applicant.appTelNo2 && this.maidForm.applicant.appTelNo2 !== '')) {
            this.$store.commit(QUOTE_MAID_RISK, this.maidForm)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
            this.$router.push({ name: 'maidQuotePremium' })
          } else {
            this.promptFieldCheck()
            this.errorMessage('At least one of the contact number is required')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(QUOTE_MAID_RISK, this.maidForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 3) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
    }
    this.doInit()
  },
  beforeCreate() {
    // Dynamic Masking
    mask('fwwpnp', {
      blocks: [1, 8],
      uppercase: true,
      delimiter: ' '
    })
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
